<template>
	<ol class="eia-ordered-list">
		<slot></slot>
	</ol>
</template>

<script>
export default {
	name: 'eia-ordered-list',
};
</script>

<style lang="scss" scoped>
.eia-ordered-list {
	padding-left: 40px;
	margin-top: 16px;
	margin-bottom: 16px;
}
</style>
